import { render, staticRenderFns } from "./PersistBannerView.vue?vue&type=template&id=f606d8f8&"
import script from "./PersistBannerView.vue?vue&type=script&lang=ts&"
export * from "./PersistBannerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports